import React, { useContext, useState } from "react"
import isEmail from "validator/lib/isEmail"
import * as s from "./index.module.less"
import PhoneNumber, { isValidPhone } from "../PhoneNumber"
import SubmitButton from "../SubmitButton"
import getQueryParams from "../../utils/getQueryParams"
import { graphql, useStaticQuery } from "gatsby"
import get from "lodash/get"
import { format, isValid, parse } from "date-fns"
import HubSpot from "../../utils/HubSpot"
import { hideKitchener } from "../../config"
import { SpaceProfileContext } from "../SpaceProfile/context"
import MarketingConsentCheckbox from "../MarketingConsentCheckbox"
import submitToMailChimp from "../../utils/submitToMailChimp"

const LocationPageGetInTouchModal = () => {
  const [show, setShow] = useState(false)
  return (
    <>
      <button className="btn btn-primary" onClick={() => setShow(true)}>
        Get in touch
      </button>
      {show && <Modal show={show} toggle={() => setShow(!show)} />}
    </>
  )
}

const Modal = ({
  toggle,
  show,
  space = {},
  total_price = null,
  isCms = false,
}) => {
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [formSubmitted, setFormSubmitted] = useState(false)
  const [progress, setProgress] = useState(false)
  const [marketingEmails, setMarketingEmails] = useState(true)

  const data = useStaticQuery(graphql`
    query {
      cms {
        entry(section: "locationsPage") {
          ... on Cms_locationsPage_locationsPage_Entry {
            id
            torontoEmails: blogAuthor
            kitchenerEmails: additionalItemsTitle
          }
        }
      }
    }
  `)

  const torontoEmails = get(data, "cms.entry.torontoEmails", "")
  const kitchenerEmails = get(data, "cms.entry.kitchenerEmails", "")

  const {
    commonData: { location },
  } = useContext(SpaceProfileContext)

  const params = getQueryParams()

  const handleBgClick = () => {
    if (typeof window !== undefined && window.innerWidth > 1200) {
      toggle()
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!name || !email || !phone || !message) return

    setProgress(true)

    let toEmail = location?.get_in_touch_emails || torontoEmails

    const data = {
      fullname: name,
      email,
      phone,
      message,
      location_interest_form: "Locations Page",
      team_size: params.get("current_staff") || "N/A",
      move_in_date: params.get("move_in_date") || "N/A",
      space_type: params.get("space_type") || "N/A",
      price: "N/A",
    }

    const formData = {
      email,
      toEmail: toEmail || "mahesh.samudra@worksimply.com",
      space_id: null,
      team_size: params.get("current_staff") || "N/A",
      is_team_size_set: !!params.get("current_staff"),
      formData: [
        { label: "Name", value: name },
        { label: "Email", value: email },
        { label: "Phone number", value: phone },
        { label: "Message", value: message || "N/A" },
        { label: "Team Size", value: params.get("current_staff") || "N/A" },
        {
          label: "Searched Move-in Date",
          value: params.get("move_in_date") || "N/A",
        },
        { label: "Space Type", value: params.get("space_type") || "N/A" },
      ],
    }

    await HubSpot(
      "207bd8fc-b2ed-4852-8a22-b4a09b1207fd",
      data,
      formData,
      document.title || "Locations Page",
      `Get in touch form - Locations Page`
    )

    await submitToMailChimp(marketingEmails, name, email)

    setFormSubmitted(true)
    setProgress(false)
  }

  const image = isCms ? space.mainImage[0].url : space.hero_image_url

  return (
    <div
      className={`workplace-one-modal ${show ? "show" : ""}`}
      onClick={handleBgClick}
    >
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <img
          src={require("../../images/close.svg").default}
          className={"modal-close me-0"}
          alt="Close"
          onClick={toggle}
        />
        <div className="modal-inner">
          <div className={`form-message ${formSubmitted ? "show" : ""}`}>
            <h5 className={"mt-4 pt-2"}>
              Thanks for getting in touch. An office space expert will reach out
              to you as soon as possible.
            </h5>
          </div>

          <div className={`form-body ${formSubmitted ? "hidden" : ""}`}>
            {image && (
              <img
                src={image}
                alt=""
                width={150}
                height={90}
                className={"ask-q-image"}
              />
            )}

            <h4 className={"mb-1"}>Get in Touch</h4>
            {params.get("current_staff") && (
              <p className={`mb-1 mt-3 ${s.search_params}`}>
                <strong>
                  {params.get("current_staff")}{" "}
                  {params.get("current_staff") === "1" ? "person" : "people"}
                  {params.get("space_type")
                    ? ` • ${params.get("space_type")}`
                    : null}
                </strong>
              </p>
            )}
            {params.get("move_in_date") && (
              <p className={s.search_params}>
                <strong>
                  Move-in date: {formatDate(params.get("move_in_date"))}
                </strong>
              </p>
            )}
            <p className={`title-sub mb-4 mt-3`}>
              Dedicated to providing the ultimate in flexibility, Workplace One
              has a solution for your business needs. Learn more about our
              spaces in Toronto{hideKitchener ? "" : " and Kitchener"}.
            </p>

            <div className="form-group">
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                name={"name"}
                placeholder={"Full name *"}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                name={"email"}
                placeholder={"Email *"}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <PhoneNumber
                setPhone={setPhone}
                value={phone}
                className="form-control"
                name={"phone"}
                placeholder={"Phone Number *"}
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                value={message}
                placeholder={"Your message *"}
                onChange={(e) => setMessage(e.target.value)}
                rows="6"
                className="form-control"
              />
            </div>
          </div>

          <MarketingConsentCheckbox
            checked={marketingEmails}
            setChecked={setMarketingEmails}
          />

          <div className={`mb-0 text-end text-md-start`}>
            {!formSubmitted ? (
              <SubmitButton
                onClick={handleSubmit}
                className={"ms-0"}
                // className={"btn btn-primary submit_get_in_touch"}
                disabled={
                  !isEmail(email) ||
                  !message ||
                  !name ||
                  !isValidPhone(phone, true)
                }
                progress={progress}
                label={"Submit"}
              />
            ) : (
              <button onClick={toggle} className={"btn btn-primary ms-0"}>
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LocationPageGetInTouchModal

const formatDate = (date) => {
  const fullDate = parse(date, "yyyy-MM-dd", new Date())
  if (!isValid(fullDate)) return ""
  return format(fullDate, "MMMM do")
}
